import TransactionRow from './TransactionRow.js';

export default TransactionRow;
